import { api } from "./auth";

export const STATUS_KESELURUHAN = {
  AKTIF: "AKTIF",
  SELESAI: "SELESAI",
  MELEWATI_BATAS: "MELEWATI_BATAS",
};

export const STATUS_TL = {
  MENUNGGU: "MENUNGGU",
  DALAM_PROSES: "DALAM_PROSES",
  SELESAI_TEPAT: "SELESAI_TEPAT",
  SELESAI_LAMBAT: "SELESAI_LAMBAT",
  MELEWATI_BATAS: "MELEWATI_BATAS",
  ESKALASI: "ESKALASI",
};

export const STATUS_TL_LABEL = {
  MENUNGGU: "Menunggu",
  DALAM_PROSES: "Dalam Proses",
  SELESAI_TEPAT: "Selesai Tepat",
  SELESAI_LAMBAT: "Selesai Lambat",
  MELEWATI_BATAS: "Melewati Batas",
  ESKALASI: "Eskalasi",
};

export const JENIS_TL = { UANG: "UANG", DOKUMEN: "DOKUMEN", KEDUANYA: "KEDUANYA" };

export function uid(prefix = "k") {
  return typeof crypto !== "undefined" && crypto.randomUUID
    ? `${prefix}-${crypto.randomUUID().slice(0, 8)}`
    : `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
}

// ---------- API functions ----------

/**
 * Load all kasus from DB.
 */
export async function loadKasus() {
  try {
    const res = await api.get("/kasus-audit");
    return Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    console.warn("auditStorage: gagal fetch kasus, fallback ke [].", err);
    return [];
  }
}

/**
 * Get a single kasus by ID from DB.
 */
export async function getKasusAPI(id) {
  const res = await api.get(`/kasus-audit/${id}`);
  return res.data;
}

/**
 * Create a new kasus in DB.
 */
export async function createKasusAPI(kasusData) {
  const res = await api.post("/kasus-audit", { data: kasusData });
  return res.data;
}

/**
 * Update an existing kasus in DB.
 */
export async function updateKasusAPI(id, kasusData) {
  const res = await api.put(`/kasus-audit/${id}`, { data: kasusData });
  return res.data;
}

/**
 * Delete a kasus from DB.
 */
export async function deleteKasusAPI(id) {
  const res = await api.delete(`/kasus-audit/${id}`);
  return res.data;
}

// ---------- Local helpers (no storage, no API — pure in-memory) ----------

export function createKasus(input) {
  return {
    id: uid("kai"),
    nomorLHP: input.nomorLHP || "",
    tanggalLHP: input.tanggalLHP || "",
    judulKasus: input.judulKasus || "",
    deskripsi: input.deskripsi || "",
    timPemeriksa: input.timPemeriksa || [],
    terperiksa: input.terperiksa || [],
    rekomendasi: (input.rekomendasi || []).map((r) => ({
      id: r.id || uid("rek"),
      uraian: r.uraian || "",
      jenisTL: r.jenisTL || JENIS_TL.DOKUMEN,
      nominalTemuan: Number(r.nominalTemuan) || 0,
      nominalKembali: Number(r.nominalKembali) || 0,
      sisaNominal: Math.max(0, (Number(r.nominalTemuan) || 0) - (Number(r.nominalKembali) || 0)),
      dokumenDiperlukan: r.dokumenDiperlukan || [],
      dokumenDiserahkan: r.dokumenDiserahkan || [],
      statusTL: r.statusTL || STATUS_TL.MENUNGGU,
      catatan: r.catatan || "",
      buktiFiles: r.buktiFiles || [],
    })),
    deadlineLHP: input.deadlineLHP || null,
    tanggalPenyerahanLaporan: input.tanggalPenyerahanLaporan || null,
    deadlineTL60HK: input.deadlineTL60HK || null,
    notifPenyerahanSent: false,
    statusKeseluruhan: STATUS_KESELURUHAN.AKTIF,
    riwayatNotifikasi: [],
    createdAt: new Date().toISOString(),
    createdBy: input.createdBy || null,
  };
}

export function upsertKasus(list, kasus) {
  const idx = list.findIndex((k) => k.id === kasus.id);
  if (idx === -1) return [...list, kasus];
  const next = [...list];
  next[idx] = kasus;
  return next;
}

export function deleteKasus(list, id) {
  return list.filter((k) => k.id !== id);
}

export function recalcRekomendasi(rek) {
  const temuan = Number(rek.nominalTemuan) || 0;
  const kembali = Number(rek.nominalKembali) || 0;
  return { ...rek, sisaNominal: Math.max(0, temuan - kembali) };
}

export function progressKasus(kasus) {
  const total = kasus.rekomendasi?.length || 0;
  if (total === 0) return 0;
  const selesai = kasus.rekomendasi.filter(
    (r) => r.statusTL === STATUS_TL.SELESAI_TEPAT || r.statusTL === STATUS_TL.SELESAI_LAMBAT,
  ).length;
  return Math.round((selesai / total) * 100);
}
